var map = {
	"./camp_entrance.json": [
		613,
		[
			613
		]
	],
	"./camp_fire.json": [
		919,
		[
			919
		]
	],
	"./forest_edge.json": [
		698,
		[
			698
		]
	],
	"./mine.json": [
		880,
		[
			880
		]
	],
	"./sans_tent.json": [
		996,
		[
			996
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 841;
module.exports = webpackAsyncContext;